
export const convertTypeToContent = (eventType: string) => {
    switch (eventType) {
        case 'AM練習':
        case 'PM練習':
            return '練習';
        default:
            return eventType;
    }
}
